import { BannerSection, SectionSubtitle } from '@web_opxp/components';
import { ETagType, renderStringToReact, useTranslation } from '@web_opxp/language';
import * as React from 'react';
import { WELCOME_ANCHOR } from '../../base/constants';
import { AssetsBaseUrl } from '../../base/env';

export interface IProps {
  onGetStarted: (event: React.MouseEvent) => void;
}

const ExercisesSection: React.FC<IProps> = ({ onGetStarted }) => {
  const { t } = useTranslation();
  const title = t('prereg:Welcome.ExercisesSection.Title');
  const descriptionHtml = t('prereg:Welcome.ExercisesSection.DescriptionHtml');
  const imgSrc = `${AssetsBaseUrl}/feature/exercises.png`;
  return (
    <BannerSection direction="left" title={title} imgSrc={imgSrc}>
      <SectionSubtitle wrapperTag="div">{renderStringToReact(descriptionHtml, ETagType.div)}</SectionSubtitle>
      <a href={`#${WELCOME_ANCHOR}`} onClick={onGetStarted}>
        {t('prereg:Welcome.ExercisesSection.Action')}
      </a>
    </BannerSection>
  );
};

export default ExercisesSection;
